var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-error-col"},[_c('div',[_vm._v(_vm._s(_vm.item.deviceName)+" ["+_vm._s(_vm.item.errorDevice)+"]")]),_c('div',[_vm._v(_vm._s(_vm.item.errorText)+" ["+_vm._s(_vm.item.errorCode)+"]")])])}
var staticRenderFns = []

export { render, staticRenderFns }